(function (angular) {

  angular.module("alk.singlesearch", []);

})(window.angular);

require("./singleSearch.service");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-single-search/module.js